import { CellContext, ColumnDef, createColumnHelper } from '@tanstack/react-table';

import { AdaptiveTableCell } from '@components/common';

import { IConsistencyCheckHistory } from '@interfaces/cmModule/consistencyCheck';

interface IColumns {
	openConsistencySummary: (selectedConsistencyCheckRan: IConsistencyCheckHistory) => void;
}

const columnHelper = createColumnHelper<IConsistencyCheckHistory>();

export const getColumns = ({
	openConsistencySummary,
}: IColumns): ColumnDef<any>[] => [
	columnHelper.accessor('createdAtText', {
		header: 'Date',
		cell: ({ getValue }: CellContext<IConsistencyCheckHistory, any>) => {
			const value = getValue();

			return <AdaptiveTableCell text={value}/>;
		},
	}),
	columnHelper.accessor('goldenTemplateName', {
		header: 'Reference Template',
		cell: ({ getValue }: CellContext<IConsistencyCheckHistory, any>) => {
			const value = getValue();

			return <AdaptiveTableCell text={value}/>;
		},
	}),
	columnHelper.accessor('consistencyStatus', {
		header: () => <>Consistency<br/>Status</>,
		enableSorting: false,
		cell: ({ row: { original } }: CellContext<IConsistencyCheckHistory, any>) => {
			const { consistencyStatus } = original || {};

			const onClick = () => {
				openConsistencySummary(original);
			};

			return (
				<AdaptiveTableCell
					actionHandler={consistencyStatus ? onClick : undefined}
					color={consistencyStatus?.color}
					text={consistencyStatus?.title || '-'}
				/>
			);
		},
	}),
	columnHelper.accessor('triggerSource', {
		header: 'Trigger source',
		enableSorting: false,
		cell: ({ getValue }: CellContext<IConsistencyCheckHistory, any>) => {
			const { title } = getValue() || {};

			return <AdaptiveTableCell text={title}/>;
		},
	}),
	columnHelper.accessor('userName', {
		header: 'Initiating user',
		enableSorting: false,
		cell: ({ getValue }: CellContext<IConsistencyCheckHistory, any>) => {
			const value = getValue();

			return <AdaptiveTableCell text={value}/>;
		},
	}),
];
